export default __webpack_public_path__ + "static/media/rambouillet18.598a02c6.jpg";